import { useNavigate, useSearchParams } from 'react-router';
import LoginForm from '../../features/auth/components/LoginForm';
import { useAuth } from '../../features/auth/contexts/AuthContext';
import { safeRedirectTarget } from './safeRedirect';

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, error } = useAuth();

  const handleLogin = async (email: string, password: string) => {
    try {
      await login(email, password);
      navigate(safeRedirectTarget(searchParams.get('redirect')));
    } catch {
      // Error is handled by the AuthContext
    }
  };

  return <LoginForm onLogin={handleLogin} error={error} />;
};

export default LoginPage;
